{
  "vendor": {
    "shell": {
      "supplying": "مورّد لدى"
    },
    "ordersSearch": {
      "label": "ابحث برقم الأمر"
    },
    "respondHintAwaiting": "لتأكيد الأمر كما أُرسل استخدم «تأكيد الإصدار {{version}}». واختر رداً هنا فقط لتحديد تاريخ التسليم من جهتك، أو الإبلاغ عن نقص، أو طرح سؤال، أو الرفض.",
    "confirmNotesHint": "اختياري — أي شيء ينبغي أن يعرفه المشتري مع تأكيدك.",
    "answerNotesHint": "اختياري — أي شيء ينبغي أن يعرفه المشتري مع هذا الرد.",
    "chooseAnswer": "اختر رداً أولاً.",
    "orderFilters": {
      "nextStep": "ما يحتاج إليك",
      "allSteps": "كل الخطوات التالية",
      "allResponses": "كل الإجابات",
      "noMatch": "لا توجد طلبات مطابقة لهذه المرشحات.",
      "steps": {
        "acknowledge": "تأكيد الطلب",
        "dispatch": "تسجيل الإرسال",
        "invoice": "إرسال الفاتورة",
        "with_buyer": "لدى المشتري",
        "nothing": "لا إجراء مطلوب"
      },
      "responses": {
        "pending": "لا إجابة بعد",
        "acknowledged": "تم التأكيد",
        "partially_available": "متاح جزئيًا",
        "query": "سؤال",
        "declined": "مرفوض"
      }
    },
    "forms": {
      "required": "أكمل هذا الحقل.",
      "refused": "لم تُرسل تغييراتك"
    },
    "versions": {
      "title": "الإصدارات الصادرة",
      "issued": "صدر في {{date}}",
      "amended": "عُدّل في {{date}}",
      "pending": "يجري تجهيز المستند.",
      "failed": "المستند غير متاح. تواصل مع المشتري."
    }
  },
  "vendorRfq": {
    "currentOffer": {
      "sentOn": "أُرسل في {{date}}",
      "prices": "أسعارك",
      "linePrice": "{{price}} لكل {{unit}}",
      "lineTotal": "إجمالي البند شاملًا الضريبة: {{total}}",
      "terms": "شروطك",
      "subtotal": "المجموع قبل الضريبة",
      "tax": "الضريبة",
      "total": "الإجمالي",
      "notGiven": "غير محدد",
      "startFrom": "البدء من عرضي الحالي",
      "startFromHint": "ينسخ هذه الأسعار والشروط إلى النموذج أعلاه. لا يُرسل شيء حتى ترسل عرضًا معدّلًا.",
      "copied": "نُسخ عرضك الحالي إلى النموذج أعلاه. غيّر ما تحتاج إليه، ثم أرسل عرضًا معدّلًا.",
      "taxNotCopied": "لا تُنسخ نسبة الضريبة. أدخلها مجددًا في «عرضك».",
      "unchanged": "هذا عرضك الحالي دون تغيير. غيّر سعرًا أو شرطًا لإرسال عرض معدّل."
    },
    "listSearch": "ابحث برقم طلب العرض أو عنوانه",
    "listCapped": "تُعرض أول {{count}} من طلبات العروض. ابحث للعثور على البقية.",
    "notSent": "لم يتم إرسال عرضك",
    "fieldErrors": {
      "taxRate": "يجب أن تكون نسبة الضريبة بين 0 و100.",
      "moq": "يجب أن تكون أقل كمية للطلب أكبر من 0.",
      "leadTime": "يجب أن تكون مدة التوريد عدداً صحيحاً من الأيام، بين 0 و3650.",
      "validUntil": "يجب أن يكون تاريخ سريان السعر تاريخاً صحيحاً.",
      "unitPrice": "يجب أن يكون سعر {{item}} رقماً لا يقل عن 0."
    }
  },
  "secureAction": {
    "answers": {
      "confirmNoDate": "الإقرار بالأمر كما أُرسل"
    },
    "rfqSignIn": "تسجيل الدخول إلى بوابة المورد"
  },
  "vendorAgreements": {
    "search": "البحث بعنوان الاتفاقية أو مرجعها"
  }
}
